<template>
  <div class="projects" id="proyectos">
    <b-container>
      <b-row align-h="center">
        <b-col sm="8" class="text-center">
          <h1 class="font-weight-bold mb-3">
            Proyectos
          </h1>
          <p class="font-weight-light">
            Algunos de nuestros proyectos recientes.
          </p>
        </b-col>
        <b-col sm="12">
          <img
            class="projects-dots"
            :src="require('@/assets/dots.svg')"
            alt="Dots"
          />
          <ProjectsSlide class="mt-4" :items="projects" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ProjectsSlide from "@/components/ProjectsSlide";
import { db } from "../services/firebase";

export default {
  name: "Projects",
  components: {
    ProjectsSlide
  },
  data() {
    return {
      projects: []
    };
  },
  async created() {
    await db
      .collection("projects")
      .get()
      .then((docs) => {
        let projectsColl = [];

        docs.forEach(function (doc) {
          let newDoc = doc.data();
          newDoc.id = doc.id;
          projectsColl.push(newDoc);
        });

        this.projects = projectsColl;
      });
  }
};
</script>

<style scoped lang="sass">
.projects
  margin: 8rem 0
  &-dots
    position: absolute
    top: 0
    left: -109px
    transform: translate(-50%, -50%)
    width: 200px
    @media screen and (max-width: 502px)
      left: -50px;
      opacity: 0.4
      top: -50px
</style>
